import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
import Infrastructure from "./components/Infrastructure";
import Contact from "./components/Contact";
import EcoCrafted from "./components/EcoCrafted";
import ProductDetails from "./components/ProductDetails";
import Luxicore from "./components/Luxicore";
import VivaWood from "./components/VivaWood";
import Warranty from "./components/Warranty";
import InstallationGuide from "./components/InstallationGuide";
import ProductSpecs from "./components/ProductSpecs";

const App = () => {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/infrastructure" element={<Infrastructure />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/category/:id" element={<EcoCrafted />} />
        <Route path="/product-details/:productId" element={<ProductDetails />} />
        <Route path="/luxicore-legacy" element={<Luxicore />} />
        <Route path="/viva-wood" element={<VivaWood />} />
        <Route path="/warranty" element={<Warranty />} />
        <Route path="/installation-guide" element={<InstallationGuide />} />
        <Route path="/product-specs" element={<ProductSpecs />} />
      </Routes>
      <Footer />
    </>
  );
};

export default App;
